import { Filter, Operators, SHIPMENTS_TABLE_TABS, ORDER_SHIPMENT_SEARCH_OPTIONS_LS } from "../constants";

export const getShipmentSearchFilters = (activeShipmentTabId) => {
  // allpickedorder
  if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.ALL_PICKED_ORDERS.value) {
    const allOrdersPickedOrders: Filter[] = [
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
      { field: "pickingStatus", operator: Operators.EQ, value: "Picked" },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
      { field: "requestedShippingClass", operator: Operators.NE, value: "Click & Collect" },
    ];
    return allOrdersPickedOrders;
  }
  // pickandpack
  else if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.PICK_AND_PACK.value) {
    const pickAndPackOrders: Filter[] = [{ field: "shippingStatus", operator: Operators.EQ, value: "PickAndPack" }];
    return pickAndPackOrders;
  }
  // shipped
  else if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.SHIPPED.value) {
    const shippedOrders: Filter[] = [{ field: "shippingStatus", operator: Operators.EQ, value: "Shipped" }];
    return shippedOrders;
  }
  //all orders
  else if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.ALL_ORDERS.value) {
    const allOrders: Filter[] = [];
    return allOrders;
  }
  //error
  else if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.ERROR.value) {
    const error: Filter[] = [
      { field: "shippingStatus", operator: Operators.EQ, value: "Error" },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
    ];
    return error;
  }
  //clickandcollect
  else if (activeShipmentTabId === SHIPMENTS_TABLE_TABS.CLICK_AND_COLLECT.value) {
    const clickAndCollect: Filter[] = [
      { field: "shippingStatus", operator: Operators.IN, value: ["ReadyToPrint", "Unshipped", "Error"] },
      { field: "pickingStatus", operator: Operators.EQ, value: "Picked" },
      { field: "issueStatus", operator: Operators.EQ, value: "NoIssue" },
      { field: "requestedShippingClass", operator: Operators.EQ, value: "Click & Collect" },
    ];
    return clickAndCollect;
  }
};
